import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import router from "./router";
import store from "./store";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import "./assets/styles/general.scss";
import "./assets/styles/warehouse.scss";
import "./assets/styles/item.scss";
import "./assets/styles/setupWizard.scss";
import { siteConfig } from "./config.js"; // load global config file
import vueClickOutsideElement from 'vue-click-outside-element'

Vue.prototype.$config = siteConfig;

axios.defaults.baseURL = Vue.prototype.$config.api;
localStorage.setItem("API", Vue.prototype.$config.api);

Vue.config.productionTip = false; // turn on/off annoying production tip
Vue.config.silent = true; // turn on/off warnings in console

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "delete",
  buttonFalseText: "cancel",
  buttonTrueColor: "secondary",
  buttonFalseColor: "grey",
  buttonTrueFlat: false,
  buttonFalseFlat: true,
  color: "primary",
  icon: "",
  title: "",
  persistent: true,
  property: "$confirm",
});


Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi",
});

Vue.use(vueClickOutsideElement);

// GLOBAL COMPONENTS
// -----------------------------------------------------------------------------
import "@/components/globalComponents";

// MIXINS
// -----------------------------------------------------------------------------
import mixins from "./plugins/mixins.js";
Vue.mixin(mixins);

// ROUTES
// -----------------------------------------------------------------------------

router.beforeEach((to, from, next) => {
  if (to.name == "login" || to.name == "resetPassword") {
    next();

  } else if (to.name == "logout") {
    store.dispatch("logout").then(() => {
      next({ name: "login" });
    });

  } else {

    // user not logged in
    if (store.state.currentUser == null) {
      
      // var authToken = localStorage.getItem('authToken');
      var authToken = sessionStorage.getItem("authToken");
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      // no token in storage ... logout and redirect to the login screen
      if (authToken == "null" || authToken == null || currentUser === null || currentUser === 'null') {
        store.dispatch("logout").then(() => {
          next({ name: "login" });
        });
      }

      // token available, re-init user
      else {
        axios.defaults.baseURL = localStorage.getItem("API");
        store
          .dispatch("init", {
            user: currentUser,
            token: authToken,
            i18n,
            vuetify,
          })
          .then((res) => {
            next();
          });
      }

      // default route (user logged in)
    } else {
      next();
    }
  }
});


const app = new Vue({
  created() {
  },
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
